export default "__VITE_ASSET__ead49b7d__"